import React, { Component } from "react";
import { connect } from "react-redux";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
} from "reactstrap";
import Select from "react-select";
import { getMiniLocations } from "../../../store/Mini/actions";
import {
  getSubLocations,
  InputChangeValue,
  SelecteChangeValue,
  SublocationAdd,
  model_open,
  model_close,
} from "../../../store/Masters/SubLocations/actions";

class AddSubLocations extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.ChangeHandeler = this.ChangeHandeler.bind(this);
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }
  componentDidMount() {
    this.props.getMiniLocations();
  }
  ChangeHandeler(e) {
    this.props.InputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  handleValidSubmit() {
    var data = this.props.rowdata;
    if (data.location_id == null) {
      // var errorLoc = "Select Location";
    } else {
      if (data.name == null) {
        // var errorSubLoc = "Enter Location";
      } else {
        var values = {
          id: data.id,
          name: data.name,
          location_id: data.location_id,
          cost_center_type : data.costCenterId
        };

        this.props.SublocationAdd(values);
      }
    }
  }

  render() {
    var data = this.props.rowdata;
    console.log("Data..",data)
    const COST_CENTER_TYPE_CHOICES = [{id:1,name:"Company"},{id:2,name:"personal"}]
    return (
      <React.Fragment>
        <Modal isOpen={this.props.model} backdrop="static" centered size="lg">
          <ModalHeader toggle={() => this.props.model_close()}>
            ADD SUB LOCATION
          </ModalHeader>
          <AvForm
            className="form-horizontal"
            onValidSubmit={this.handleValidSubmit}
          >
            <ModalBody>
              <Row className="justify-content-center">
                <Col md={10}>
                  <Row className="justify-content-center">
                    <Col md={9}>
                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="Location_id_select"
                            className="col-form-label float-right"
                          >
                            Select Location
                          </Label>
                        </Col>
                        <Col md={8}>
                          <Select
                            id="Location_id_select"
                            name="Location_id_select"
                            classNamePrefix="select2-selection"
                            isClearable={
                              this.props.rowdata?.locationsLabel ? true : false
                            }
                            options={this.props.locationslist.map(
                              (item, index) => ({
                                label: item.name,
                                value: item.id,
                              })
                            )}
                            value={{
                              label:
                                data.locationsLabel == null
                                  ? "select Cost Center Type"
                                  : data.locationsLabel,
                              value: data.location_id,
                            }}
                            onChange={(e) => {
                              this.props.SelecteChangeValue({
                                key: "locationsLabel",
                                label: e?.label,
                                key2: "location_id",
                                value: e?.value,
                              });
                            }}
                          />
                          {/* {data.location_id == null && (
                            <Label className="text-danger m-0">
                              {errorLoc}
                            </Label>
                          )} */}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="LocationName"
                            className="col-form-label float-right"
                          >
                            Sub Location Name
                          </Label>
                        </Col>
                        <Col md={8}>
                          <AvField
                            name="name"
                            type="text"
                            value={data.name}
                            onChange={this.ChangeHandeler}
                            className="form-control"
                            id="LocationName"
                            placeholder="Enter Location Name"
                            errormessage=" Please provide a valid Location Name"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </FormGroup>



                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="Cost_center_id_select"
                            className="col-form-label float-right"
                          >
                          Cost Center Type
                          </Label>
                        </Col>
                        <Col md={8}>
                          <Select
                            id="Cost_center_id_select"
                            name="Cost_center_id_select"
                            classNamePrefix="select2-selection"
                            isClearable={
                              this.props.rowdata?.costCenterType ? true : false
                            }
                            options={COST_CENTER_TYPE_CHOICES.map(
                              (item, index) => ({
                                label: item.name,
                                value: item.id,
                              })
                            )}
                            value={{
                              label:
                                data.costCenterType == null
                                  ? "Select Cost Center Type"
                                  : data.costCenterType,
                              value: data.costCenterId,
                            }}
                            onChange={(e) => {
                              this.props.SelecteChangeValue({
                                key: "costCenterType",
                                label: e?.label,
                                key2: "costCenterId",
                                value: e?.value,
                              });
                            }}
                          />
                          {/* {data.costCenterId == null && (
                            <Label className="text-danger m-0">
                              {errorLoc}
                            </Label>
                          )} */}
                         </Col>
                      </FormGroup>



                      <FormGroup>
                        <AvField
                          className="form-control"
                          type="hidden"
                          value={data.id}
                          id="id"
                          name="id"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <ModalFooter>
                <Button
                  type="button"
                  className="btn btn-danger"
                  color="light"
                  onClick={() => this.props.model_close()}
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="btn btn-primary"
                  color="primary"
                >
                  Save
                </Button>
              </ModalFooter>
            </ModalBody>
          </AvForm>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { locationslist } = state.Mini;
  const { Sublocationlist, model, rowdata } = state.SubLocation;
  return { locationslist, Sublocationlist, model, rowdata };
};

export default connect(mapStatetoProps, {
  getMiniLocations,
  getSubLocations,
  InputChangeValue,
  SelecteChangeValue,
  SublocationAdd,

  model_open,
  model_close,
})(AddSubLocations);
